import { createContext } from "react";
const finesContext = createContext();
export default finesContext;
